module.exports = __webpack_public_path__ + "media/error.2953c597.mp3";